export class Sms {

  constructor(
    //public phoneNumber: string
    public phoneNumber: number
  ) { }
}
